import { render, staticRenderFns } from "./bachelorInfo.vue?vue&type=template&id=42ca2d94&"
import script from "./bachelorInfo.vue?vue&type=script&lang=js&"
export * from "./bachelorInfo.vue?vue&type=script&lang=js&"
import style0 from "./bachelorInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports